<template>
    <div v-if="!showOTP && !showAccountSelection" class="login">
        <img alt="Login" src="../assets/welcome.png" style="width: 360px" />
        <div class="loginComponent">
            <form @submit.prevent="showForgotPassword ? getForgotPasswordOtp() : login()">
                <div class="heading">{{`${showForgotPassword ? 'Forgot Password' : 'Login to JioMart Ads'}`}}</div>
                <div class="inputWrapper"> 
                    <label class="label">User Name</label>
                    <input class="input" type="email" placeholder="Enter your username" v-model="email" required>
                </div>
                <div class="inputWrapper" style="position: relative"> 
                    <label class="label">{{`${showForgotPassword ? 'New' : ''} Password`}}</label>
                    <input class="input" :type="showPassword ? 'text' : 'password'" placeholder="Enter your password" v-model="password" required>
                    <span class="password-toggle-icon">
                        <img v-if="showPassword" src="../assets/eyeSlashIcon.svg" @click="toggleEye" />
                        <img v-else  src="../assets/eyeIcon.svg" @click="toggleEye" />
                    </span>
                </div>
                <div v-if="showForgotPassword" class="inputWrapper" style="position: relative"> 
                    <label class="label">Confirm Password</label>
                    <input class="input" :type="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm password" v-model="confirmPassword" required>
                    <span class="password-toggle-icon">
                        <img v-if="showConfirmPassword" src="../assets/eyeSlashIcon.svg" @click="toggleConfirmEye" />
                        <img v-else src="../assets/eyeIcon.svg" @click="toggleConfirmEye" />
                    </span>
                </div>
                <div class="errorContainer" v-if="apiError"> 
                    <div class="error">{{ this.apiError }}</div>
                </div>
                <div style="display: flex; align-items: center">
                    <button class="btn" type="submit">{{`${showForgotPassword ? 'Get OTP' : 'Login'}`}}</button>
                    <span style="margin: 0px 16px; color: #d3d3d3"> | </span>
                    <p class="forgot" @click="toggleForgotPassword">{{`${showForgotPassword ? 'Back to Login' : 'Forgot Password?'}`}}</p>
                </div>

                <div v-if="showWarningModal"> 
                    <LoginWarningModal  @cancelClicked="onCloseModal" @continueClicked="login({loginHere: 'true'})"></LoginWarningModal>
                </div>
            </form>
        </div>
    </div>
    <div v-else-if="showAccountSelection">
        <!-- <AccountSelection /> -->
    </div>
    <TwoFaDialog v-else :qrCode="qrCode" :errorMessage="otpError" @verifyOtp="verifyOtp" />
    <ForgotPasswordOTP
        v-if="showForgotOtpDialog" 
        :errorMessage="otpError"
        @cancelClicked="onCloseForgotOtpDialog"
        @resetPassword="handleResetPassword"
    />
    <ConfirmationModal
        v-if="showPasswordResetSuccess"
        :title="'Password Reset Successful'"
        :subTitle="'Your password has been updated successfully!'"
        @cancelClicked="onCloseSuccess"
    />
</template>
    
     
<style scoped>

@font-face {
    font-family: "Inter-Regular" ;
    src: url('../assets/fonts/Inter-Regular.ttf');
}

.error{
    font-family: "Inter-Regular" ;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    margin-bottom: 25px;
}

.or{
    margin: 10px 50px 10px;
}

.inputWrapper{
    margin-bottom: 25px;
    display: flex;
    flex-direction: column;
}

.input{
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    height: 40px;
    padding-left: 10px;

}

.input::placeholder{
    color: #9B9B9B;
    /* padding-left: 10px; */

}

.btn{
    cursor: pointer;
    background: #0078AD;
    border-radius: 32px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #FFFFFF;
    padding: 14px 40px;
    border: unset;
}

.heading{
    margin-bottom: 8px;
    font-family: "Inter-Regular";
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 140%;
    display: flex;
    align-items: center;
    color: #141414;
    margin-bottom: 40px;
}

.loginComponent{
    font-family: "Inter-Regular";
    padding: 50px;
    width: 700px;
    height: 417px;
    background: #FFFFFF;
    border: 1px solid #F3F3F3;
    border-radius: 12px;
    margin: 50px 0 0 190px;
    margin: 50px auto;
} 
    .label{
        font-family: "Inter-Regular";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #9B9B9B;
        margin-bottom: 8px;
    }
    .login{
        display: flex;
        overflow: auto;
    }
    .password-toggle-icon {
        position: absolute;
        top: 55%;
        right: 10px;
        cursor: pointer;
    }

    .password-toggle-icon img {
        color: #333;
        width: 18px;
        height: 18px;
    }
    .forgot {
        color: rgb(0, 120, 173);
        cursor: pointer;
        font-family: helvetica, arial, sans-serif;
    }
</style>

<script>
    import {API_AUTH_URL} from '../constants/index';
    import Header from './Header.vue';
    import { clearCookie, getCookie, getLoggedSellerId, getQRTwoFactorAuth, getResetPasswordOTP, resetPassword, setCookie, twoFaVerifyOtp } from '../services/campaignService';
    import LoginWarningModal from './LoginWarningModal.vue';
    import AccountSelection from './AccountSelection.vue';
    import TwoFaDialog from './TwoFaDialog.vue';
    import ForgotPasswordOTP from './ForgotPasswordOTP';
    import ConfirmationModal from './ConfirmationModal';

    export default {
    name: 'App',
    components: {
        LoginWarningModal,
        Header,
        AccountSelection,
        TwoFaDialog,
        ForgotPasswordOTP,
        ConfirmationModal,
    },
    data() {
        return {
            email: '',
            password: '',
            confirmPassword: '',
            apiError: '',
            showWarningModal: false,
            showAccountSelection: false,
            showOTP: false,
            qrCode: '',
            otpError: '',
            loginData: null,
            showPassword: false,
            showConfirmPassword: false,
            showForgotPassword: false,
            showForgotOtpDialog: false,
            showPasswordResetSuccess: false,
        };
    },
    mounted() {
        this.showOTP = getCookie('token');
        this.showAccountSelection = getCookie('token') && !getLoggedSellerId() && this.role !== 'SELLER' && this.role !== 'BRAND' && 
            (this.role === 'AGENCY' ? getCookie('tncAcceptance') === 'true' : true);
        if(this.showAccountSelection)
            this.$router.push(`${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/select-account`)
    },
    computed: {
        role() {
            return getCookie('role');
        }
    },
    methods: {
        toggleEye() {
            this.showPassword = !this.showPassword;
        },
        toggleConfirmEye() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        toggleForgotPassword() {
            this.email = "";
            this.password = "";
            this.confirmPassword = "";
            this.showPassword = false;
            this.showConfirmPassword = false;
            this.apiError = "";
            this.showForgotPassword = !this.showForgotPassword;
        },
        onCloseForgotOtpDialog() {
            this.showForgotOtpDialog = false;
        },
        onCloseSuccess() {
            this.showPasswordResetSuccess = false;
        },
        async login(value) {
            try {

                let params = {
                    email: this.email,
                    password: this.password
                }
                if (value?.loginHere) {
                    params.loginHere = true;
                }

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json'},
                    body: JSON.stringify(params)
                };
                const url = `${API_AUTH_URL}/v1/login`;

                await fetch(url, requestOptions)
                .then(res=>res.json())
                .then(data => {
                    this.onLoginResponse(data);
                    if(data?.code !==200){
                        if(data?.code === 401 && data?.message === 'User already Logged in from another device!'){
                            this.showWarningModal = true
                        }else{
                            this.apiError = data?.message
                        }
                    }
                }).catch(error => console.log(error));
                // Handle successful login
            } catch (error) {
                console.log(error);
            }
        },
        async verifyOtp(otp) {
            const paylaod = {
                email: this.loginData.email,
                totp: otp,
            }
            await twoFaVerifyOtp(paylaod, this.loginData)
                .then(res => res.json())
                .then(data => {
                    if(data?.token) {
                        this.showAccountSelection = true;
                        setCookie('token', data.token, data.expireTime)
                        setCookie('userId', data.userId, data.expireTime)
                        setCookie('userEmail', data.email, data.expireTime)
                        setCookie('role', data?.role, data.expireTime)
                        setCookie('ipAddress', data?.ipAddress, data.expireTime)
                        if(data?.role === 'SELLER' || data?.role === 'BRAND' || data?.role === 'AGENCY') { 
                            setCookie('tncAcceptance', data?.tncVersion == 'v2' ? data?.tncAcceptance : false);
                            if(data?.role !== 'AGENCY') setCookie('sellerId',data.userId, data.expireTime)
                        }
                        this.$router.go(0);
                        if(this.role == 'SELLER' || this.role == 'BRAND') {
                            this.$router.replace('/campaigns');
                        }
                    } else {
                        this.otpError = data?.errors?.[0] || data?.message || 'Invalid OTP'
                    }
                })
                .catch(error => {
                    this.otpError = error?.errors?.[0] || error?.message || 'Invalid OTP'
                })
        },
        onLoginClick() {
            window.location.replace(`${API_AUTH_URL}/v1/external/open-ads`);
            // const requestOptions = {
            //     method: 'GET',
            //     headers: {
            //     'Accept': 'text/html',
            //     },

            // };

            // fetch(`${API_AUTH_URL}/v1/external/open-ads`, requestOptions)
            //     .then(response => response.text())
            //     .then(data => {
            //     const popupWindow = window.open("", "_blank");
            //     popupWindow.document.write(data);
            //     })
            //     .catch(error => {
            //     console.error(error);
            //     });
        },
        onCloseModal(){
            this.showWarningModal = false
        },
        async onLoginResponse(data){
            if(data.code === 200) {
                this.loginData = data?.data;
                setCookie('twoFactorRegistered', data?.data.twoFactorRegistered);
                this.showOTP = true;
                this.otpError = "";
                if(!data?.data?.twoFactorRegistered) {
                    await getQRTwoFactorAuth(this.loginData)
                        .then(res => res.blob())
                        .then(blob => {
                            var img = URL.createObjectURL(blob);
                            this.qrCode = img;
                            clearCookie('twoFactorRegistered');
                        })
                }
            }
        },
        async getForgotPasswordOtp() {
    if (this.password !== this.confirmPassword) {
        this.apiError = "Password does not match";
        return;
    }
    this.apiError = "";
    try {
        const res = await getResetPasswordOTP(this.email);
        console.log(res);

        if (res.status === 429) {
            this.apiError = "Too many requests. Please try again later."; // or use errorText if you want to display the HTML
            return;
        }

        const data = await res.json();

        if (data.code === 200) {
            this.showForgotOtpDialog = true;
            this.otpError = "";
        } else {
            this.apiError = data?.errors?.[0] || data?.message || 'Something went wrong';
        }
    } catch (error) {
        this.apiError = error?.errors?.[0] || error?.message || 'Something went wrong';
    }
},
        async handleResetPassword(otp) {
            try {
                const payload = {
                    email: this.email,
                    password: this.password,
                    confirmPassword: this.confirmPassword,
                    otp,
                };

                const response = await resetPassword(payload).then((res) => res.json());
                
                if (response.code === 200) {
                    this.showForgotOtpDialog = false;
                    this.toggleForgotPassword();
                    this.otpError = "";
                    this.showPasswordResetSuccess = true;
                } else {
                    this.otpError = response?.errors?.[0] || response?.message || 'Something went wrong';
                }
            } catch (error) {
                this.otpError = error?.errors?.[0] || error?.message || 'Something went wrong';
            }
        }
    }
    };
    </script>